<mat-form-field>
  <mat-label>Utländskt skatteregistreringsnummer (TIN)</mat-label>
  <input #input="ngModel" [(ngModel)]="model" matInput maxlength="25" required>

  @if (input.errors) {
    <mat-error>Vänligen kontrollera fältet
    </mat-error>
  }

  @if (input.errors && input.touched) {
    <mat-icon matIconSuffix aria-hidden="true">
      priority_high
    </mat-icon>
  }
</mat-form-field>
